import { ToolType } from '../customization';
import { MouseMove } from '../labeling-screen/segment-image';
// TODO move screenText into your mock
// users are complaning that seeing this customization when
// their template loads is annoying
import {
  screenText,
  Customization,
  ClassificationField,
  Tool,
} from '../customization';
import {
  selectAnnotationsFromLabel,
  selectClassificationFieldsFromLabel,
  getSelectedRectangleTool,
} from './app.selectors';
import { guid } from '../utils/utils';

export const defaultState = {
  loading: true,
  tileLayerInfo: undefined,
  currentToolId: undefined,
  annotations: [],
  drawnAnnotationBounds: [],
  hiddenTools: [],
  searchFocused: false,
  searchValue: '',
  deletedAnnotations: [],
  showVideo: false,
  tools: screenText.tools,
  classificationFields: screenText.classificationFields,
  showLabelInfo: false,
};

export enum CoordinateSystems {
  EPSG3395 = 'EPSG3395',
  EPSG3857 = 'EPSG3857',
  EPSG4326 = 'EPSG4326',
  Earth = 'Earth',
  Simple = 'Simple',
}

enum Types {
  ANY = 'Any',
  SKIP = 'Skip'
}

export type Action = {type: any, payload?: any};

export enum Actions {
  // TODO this is just a temporary action so I can move everything into redux
  SYNC = 'SYNC',
  USER_CLICKED_SET_TOOL = 'USER_CLICKED_SET_TOOL',
  USER_CLICKED_ANNOTATION = 'USER_CLICKED_ANNOTATION',
  USER_FINISHED_CREATING_ANNOTATION = 'USER_FINISHED_CREATING_ANNOTATION',
  USER_PRESSED_ESCAPE = 'USER_PRESSED_ESCAPE',
  USER_DESELECTED_ANNOTATION = 'USER_DESELECTED_ANNOTATION',
  IMAGE_FINISHED_LOADING = 'IMAGE_FINISHED_LOADING',
  USER_ANSWERED_CLASSIFCIATION = 'USER_ANSWERED_CLASSIFCIATION',
  USER_MOVED_LAYER_DOWN = 'USER_MOVED_LAYER_DOWN',
  USER_MOVED_LAYER_UP = 'USER_MOVED_LAYER_UP',
  USER_FOCUSED_SEARCH = 'USER_FOCUSED_SEARCH',
  LABELBOX_API_LOADED = 'LABELBOX_API_LOADED',
  LABELBOX_API_EMITTED_NEW_ASSET = 'LABELBOX_API_EMITTED_NEW_ASSET',
  LABELBOX_API_EMITTED_NEW_CUSTOMIZATION = 'LABELBOX_API_EMITTED_NEW_CUSTOMIZATION',
  NEW_IMAGE_FINISHED_LOADING = 'NEW_IMAGE_FINISHED_LOADING',
  NEW_IMAGE_FAILED_TO_LOAD = 'NEW_IMAGE_FAILED_TO_LOAD',
  NEW_WMS_TILE_LAYER = 'NEW_WMS_TILE_LAYER',
  USER_SEARCHED = 'USER_SEARCHED',
  USER_UPDATED_GEOMETRY_OF_DRAWN_SHAPE = 'USER_UPDATED_GEOMETRY_OF_DRAWN_SHAPE',
  USER_TOGGLED_VIDEO = 'USER_TOGGLED_VIDEO',
  USER_PRESSED_PERIOD = 'USER_PRESSED_PERIOD',
  USER_RELEASED_PERIOD = 'USER_RELEASED_PERIOD',
}

export const userPressedPeriod = () => ({ type: Actions.USER_PRESSED_PERIOD });
export const userReleasedPeriod = () => ({ type: Actions.USER_RELEASED_PERIOD });

// TODO delete
export function syncState(newState: AppState){
  return {
    type: Actions.SYNC,
    payload: {
      state: newState
    }
  }
}

export function userFocusedSearch(focused: boolean){
  return {
    type: Actions.USER_FOCUSED_SEARCH,
    payload: {focused}
  }
}

export function userSearched(searchValue: string){
  return {
    type: Actions.USER_SEARCHED,
    payload: {searchValue}
  }
}

export function labelBoxApiLoaded(){
  return {
    type: Actions.LABELBOX_API_LOADED,
    payload: {}
  }
}

export function userPressedEscape(){
  return {
    type: Actions.USER_PRESSED_ESCAPE,
    payload: {}
  }
}

export function labelboxApiEmittedNewCustomization(customization: Customization){
  return {
    type: Actions.LABELBOX_API_EMITTED_NEW_CUSTOMIZATION,
    payload: {customization}
  }
}


interface SetTileLayerInfo {
  bounds: [number, number][]
  wmsTileUrl?: string,
  layerName?: string,
  minZoom?: number,
  maxZoom?: number,
}

export function newWMSTileLayer(asset: Asset, tileLayerInfo: SetTileLayerInfo){
  return {
    type: Actions.NEW_WMS_TILE_LAYER,
    payload: {asset, tileLayerInfo}
  }
}

export function newImageFinishedLoading(asset: Asset, imageSize: {height: number, width: number}){
  return {
    type: Actions.NEW_IMAGE_FINISHED_LOADING,
    payload: {asset, imageSize}
  }
}

export function newImageFailedToLoad(imageUrl: string){
  return {
    type: Actions.NEW_IMAGE_FAILED_TO_LOAD,
    payload: {imageUrl}
  }
}

export function userDeselectedAnnotation(){
  return {
    type: Actions.USER_DESELECTED_ANNOTATION,
    payload: {}
  }
}

export function userAnsweredClassification(fieldId: string, answer: string | string[]){
  return {
    type: Actions.USER_ANSWERED_CLASSIFCIATION,
    payload: {fieldId, answer}
  }
}

export function userClickedSetTool(toolId: string) {
  return {
    type: Actions.USER_CLICKED_SET_TOOL,
    payload: {toolId}
  }
}

export function userFinishedAnnotation(geometry: Geometry){
  return {
    type: Actions.USER_FINISHED_CREATING_ANNOTATION,
    payload: {geometry}
  }
}

export function userUpdatedGeometryOfDrawnShape(geometry: Geometry){
  return {
    type: Actions.USER_UPDATED_GEOMETRY_OF_DRAWN_SHAPE,
    payload: {geometry}
  }
}

export function userClickedAnnotation(annotationId: string) {
  return {
    type: Actions.USER_CLICKED_ANNOTATION,
    payload: {annotationId}
  }
}

export function userToggledVideo(showVideo: boolean){
  return {
    type: Actions.USER_TOGGLED_VIDEO,
    payload: {showVideo}
  }
}

export const userMovedLayerDown = () => {
  return {
    type: Actions.USER_MOVED_LAYER_DOWN,
    payload: {}
  }
}

export const userMovedLayerUp = () => {
  return {
    type: Actions.USER_MOVED_LAYER_UP,
    payload: {}
  }
}

export const imageFinishedLoading = ():Action => {
  return {
    type: Actions.IMAGE_FINISHED_LOADING,
    payload: {}
  }
}

enum OrderTo {
  top = 'top',
  bottom = 'bottom',
}

function reorderSelectedAnnotation(state: AppState, orderTo: OrderTo){
  const selectedAnnotationIndex = state.annotations.findIndex(({editing}) => editing === true);
  if (selectedAnnotationIndex === -1){
    return state;
  }
  const selected = state.annotations[selectedAnnotationIndex];
  const annotations = [
    ...state.annotations.slice(0, selectedAnnotationIndex),
    ...state.annotations.slice(selectedAnnotationIndex + 1),
  ]
  return {
    ...state,
    annotations: orderTo === OrderTo.top ?
              [...annotations, selected] :
              [selected, ...annotations],
  }
}

export const appReducer = (state: AppState = defaultState, action: any = {}): AppState => {
  const { type, payload } = action;
  switch (type) {
    case Actions.SYNC: {
      return payload.state;
    }
    case Actions.USER_CLICKED_SET_TOOL: {
      return {
        ...deselectAllAnnotations(state),
        currentToolId: payload.toolId
      };
    }
    case Actions.USER_FINISHED_CREATING_ANNOTATION: {
      return onNewAnnotation(state, payload.geometry);
    }
    case Actions.USER_CLICKED_ANNOTATION: {
      return userSelectedAnnotationToEdit(state, payload.annotationId);
    }
    case Actions.USER_MOVED_LAYER_UP: {
      return reorderSelectedAnnotation(state, OrderTo.top);
    }
    case Actions.USER_UPDATED_GEOMETRY_OF_DRAWN_SHAPE:{
      return processGeomtryChangeOfEditedShape(state, payload.geometry)
    }
    case Actions.USER_TOGGLED_VIDEO: {
      return {
        ...state,
        showVideo: payload.showVideo
      }
    }
    case Actions.LABELBOX_API_EMITTED_NEW_ASSET: {
      if (!payload.asset) {
        return {
          ...state,
          loading: true,
          tileLayerInfo: undefined
        }
      } else {
        return state;
      }
    }
    case Actions.NEW_IMAGE_FINISHED_LOADING: {
      return setAssetToLabel({
        state,
        asset: payload.asset,
        tileLayerInfo: {
          epsg: CoordinateSystems.Simple,
          bounds: [[0,0], [payload.imageSize.height, payload.imageSize.width]],
          imageUrl: JSON.parse(payload.asset.data).imageUrl
        }
      });
    }
    case Actions.NEW_WMS_TILE_LAYER: {
      const {
        bounds,
        wmsTileUrl,
        layerName,
        minZoom = undefined,
        maxZoom = undefined,
      } = payload.tileLayerInfo;
      return setAssetToLabel({
        state,
        asset: payload.asset,
        tileLayerInfo: {
          epsg: CoordinateSystems.Earth,
          bounds,
          wmsTileUrl,
          layerName,
          minZoom,
          maxZoom
        }
      });
    }
    case Actions.USER_MOVED_LAYER_DOWN: {
      return reorderSelectedAnnotation(state, OrderTo.bottom);
    }
    case Actions.USER_DESELECTED_ANNOTATION: {
      return deselectAllAnnotations(state);
    }
    case Actions.USER_PRESSED_ESCAPE: {
      return {
        ...deselectAllAnnotations(removeTempBoundingBox(state)),
        currentToolId: undefined,
        searchFocused: false,
        searchValue: '',
      }
    }
    case Actions.USER_SEARCHED: {
      return {
        ...state,
        searchValue: payload.searchValue
      }
    }
    case Actions.USER_FOCUSED_SEARCH: {
      return {
        ...state,
        searchFocused: payload.focused
      }
    }
    case Actions.LABELBOX_API_EMITTED_NEW_CUSTOMIZATION: {
      return {
        ...state,
        tools: payload.customization.tools,
        classificationFields: payload.customization.classificationFields,
      }
    }
    case Actions.NEW_IMAGE_FAILED_TO_LOAD: {
      return {
        ...state,
        errorLoadingImage: payload.imageUrl,
        loading: false
      }
    }
    case Actions.IMAGE_FINISHED_LOADING:{
      return {
        ...state,
        loading: false
      }
    }
    case Actions.USER_ANSWERED_CLASSIFCIATION: {
      return changeClassificationAnswer(state, payload.fieldId, payload.answer);
    }
    case Actions.USER_PRESSED_PERIOD: {
      return {
        ...state,
        showLabelInfo: true,
      };
    }
    case Actions.USER_RELEASED_PERIOD: {
      return {
        ...state,
        showLabelInfo: false,
      };
    }
    default: {
      return state;
    }
  }
}
function processGeomtryChangeOfEditedShape(state: AppState, geometry: Geometry){
  // Rectangles are just polygons that we complete after the second point
  const rectangleTool = getSelectedRectangleTool(state);
  if (rectangleTool && Array.isArray(geometry) && geometry.length > 1){
    return finalizeTempBoundingBox(state);
  }

  return {
    ...state,
    drawnAnnotationBounds: geometry
  };
}

function setAssetToLabel(
  {
    state,
    asset,
    tileLayerInfo,
  }:
  {
    state: AppState,
    asset: Asset,
    tileLayerInfo: TileLayerInfo
  }
):AppState {
  // Only change the label when the asset changes
  // https://www.useloom.com/share/e59e9d5524be448ca63ddbe77a40f835
  const isNewAsset = state.assetId !== asset.id;
  return {
    ...state,
    tileLayerInfo,
    previousLabel: asset.previous,
    nextLabel: asset.next,
    videoUrl: JSON.parse(asset.data).videoUrl,
    label: state.assetId === asset.id ? state.label : asset.label,
    ... isNewAsset ? {
      assetId: asset.id,
      errorLoadingImage: undefined,
      annotations: selectAnnotationsFromLabel(state, asset.label),
      classificationFields: selectClassificationFieldsFromLabel(state, asset.label),
      searchFocused: false,
      searchValue: '',
    } : {},
    ... asset.createdAt ?
      {
        existingLabel: asset.createdBy ? {
          typeName: asset.typeName === 'Skip' ? Types.SKIP : Types.ANY,
          createdBy: asset.createdBy,
          createdAt: asset.createdAt,
        } : undefined
      } :
      {
        existingLabel: undefined
      },
  };
}

export type Geometry = {lat: number, lng:number}[] | {lat: number, lng: number};

const flatten = (arr: any[][]) => arr.reduce((all, item) => [...all, ...item], []);

function changeClassificationAnswer(state: AppState, fieldId: string, userAnswer: string | string[]) {
  if (!state.classificationFields){
    throw new Error(`Error: classificationFields should never be undefined`);
  }

  const nestedClassificationIds: string[] = flatten(state.tools.map(({classifications = []}) => classifications.map(({id}) => id)))
  const isNestedClassification = nestedClassificationIds.indexOf(fieldId) > -1;
  return {
    ...state,
    annotations: state.annotations.map((annotation) => {
      const isAnnotationSelected = annotation.editing;
      if (isAnnotationSelected && isNestedClassification){
        return {
          ...annotation,
          classificationAnswers: {
            ...(annotation.classificationAnswers || {}),
            [fieldId]: userAnswer
          }
        };
      }
      return annotation;
    }),
    classificationFields: state.classificationFields.map((field) => {
      if (field.id === fieldId){
        return {
          ...field,
          userAnswer
        }
      }
      return field;
    })
  }
}

export enum FieldTypes {
  CHECKLIST = 'checklist',
  RADIO = 'radio',
}
export type ClassificationAnswers =  {
  [toolId: string]: undefined | string | string[]
};

export interface Annotation {
  id: string;
  color: string;
  geometry: Geometry;
  editing: boolean;
  toolName: ToolType;
  toolId: string;
  classificationAnswers?: ClassificationAnswers
}

interface TileLayerInfo {
  epsg: CoordinateSystems,
  imageUrl?: string,
  wmsTileUrl?: string,
  layerName?: string,
  minZoom?: number,
  maxZoom?: number,
  bounds: [number, number][]
}

export interface AppState {
  tileLayerInfo: TileLayerInfo | undefined;

  currentToolId: string | undefined;
  annotations: Annotation[];
  hiddenTools: string[];
  searchFocused: boolean;
  searchValue: string;
  deletedAnnotations: Annotation[];
  loading: boolean;
  tools: Tool[];
  drawnAnnotationBounds: Geometry;
  classificationFields: ClassificationField[]
  showVideo: boolean;
  existingLabel?: {
    typeName: Types,
    createdBy: string,
    createdAt: string,
  };
  videoUrl?: string;
  assetId?: string;
  previousLabel?: string;
  nextLabel?: string;
  rectangleInProgressId?: string;
  errorLoadingImage?: string;
  label?: string;
  showLabelInfo?: boolean;
}

export const toggleVisiblityOfTool = (state: AppState, toolId: string) => {
  const removeItem = (arr: string[], index: number) => [ ...arr.slice(0, index), ...arr.slice(index + 1) ];
  const currentHiddenTools = state.hiddenTools || [];
  const foundIndex = currentHiddenTools.indexOf(toolId);
  const hiddenTools = foundIndex === -1 ?
    [...currentHiddenTools, toolId] :
    removeItem(currentHiddenTools, foundIndex);

  return {...state, hiddenTools};
};

function enforceBetween(min: number, max: number){
  return (num: number) => {
    if (num < min){
      return min
    }
    if (num > max){
      return max
    }

    return num
  }
}

export function restrictGeomtryToBeInsideMapBounds(state: AppState, geometry: Geometry){
  if (!state.tileLayerInfo){
    console.log('Error: Geometry was drawn before bounds has been set.')
    return geometry;
  }

  const [[minLat, minLng], [maxLat, maxLng]] = state.tileLayerInfo.bounds;
  const enforceLatRange = enforceBetween(minLat, maxLat)
  const enforceLngRange = enforceBetween(minLng, maxLng)
  const moveInsideBounds = ({lat, lng}: {lat: number, lng: number}) => {
    return {
      lat: enforceLatRange(lat),
      lng: enforceLngRange(lng),
    };
  }
  return Array.isArray(geometry) ? geometry.map(moveInsideBounds) : moveInsideBounds(geometry);
}

export function onNewAnnotation(state: AppState, geometry: Geometry): AppState {
  const currentTool = state.tools.find(({id}) => id === state.currentToolId);
  if (currentTool === undefined) {
    throw new Error('should not be able to add an annotation without a tool');
  }
  const hasNestedClassifications = Boolean(currentTool.classifications);
  return {
    ...state,
    currentToolId: undefined,
    drawnAnnotationBounds: [],
    annotations: [
      ...state.annotations,
      {
        id: guid(),
        geometry: restrictGeomtryToBeInsideMapBounds(state, geometry),
        color: currentTool.color,
        editing: hasNestedClassifications,
        toolName: currentTool.tool,
        toolId: currentTool.id
      }
    ]
  };
};

export const deleteSelectedAnnotation = (state: AppState): AppState => {
  const deleteAnnotationIndex = state.annotations.findIndex(({editing}) => editing === true);
  if (deleteAnnotationIndex !== -1) {
    return {
      ...state,
      annotations: [
        ...state.annotations.slice(0, deleteAnnotationIndex),
        ...state.annotations.slice(deleteAnnotationIndex + 1),
      ],
      deletedAnnotations: [
        {...state.annotations[deleteAnnotationIndex], editing: false},
        ...state.deletedAnnotations
      ]
    };
  } else {
    return state;
  }
}

export const updateAnnotation = (state: AppState, annotationId: string, fields: Partial<Annotation>): AppState => {
  const index = state.annotations.findIndex(({id}) => id === annotationId);
  if (index === undefined) {
    return state;
  }
  return {
    ...state,
    annotations: [
      ...state.annotations.slice(0, index),
      {
        ...state.annotations.find(({id}) => annotationId === id),
        ...fields
      } as Annotation,
      ...state.annotations.slice(index + 1),
    ]
  };
};

export function deselectAllAnnotations(state: AppState) {
  return state.annotations.filter(({editing}) => editing)
    .reduce((appState, annotation) => updateAnnotation(appState, annotation.id, {editing: false}), state);
}


export function userSelectedAnnotationToEdit(state: AppState, annotationId: string) {
  return updateAnnotation(
    deselectAllAnnotations(state),
    annotationId,
    {editing: true}
  )
};


export function removeTempBoundingBox(state: AppState) {
  return {
    ...state,
    annotations: state.annotations.filter(({id}) => id !== state.rectangleInProgressId),
    rectangleInProgressId: undefined,
    drawnAnnotationBounds: [],
  }
}

const updateTempBoundingBox = (state: AppState, {location: {lat: mouseLat, lng: mouseLng}}: MouseMove) => {
  const rectangleTool = getSelectedRectangleTool(state);
  if (!rectangleTool){
    return state;
  }
  const rectId = state.rectangleInProgressId ? state.rectangleInProgressId : guid();

  // tslint:disable-next-line
  const [{lat: startLat, lng: startLng}] = state.drawnAnnotationBounds as {lat: number, lng: number}[];
  const boxAnnotation:Annotation = {
    id: rectId,
    color: rectangleTool.color,
    geometry: [
      {lat: startLat, lng: startLng},
      {lat: mouseLat, lng: startLng},
      {lat: mouseLat, lng: mouseLng},
      {lat: startLat, lng: mouseLng},
    ],
    editing: false,
    toolName: ToolType.RECTANGLE,
    toolId: rectangleTool.id
  };

  const index = state.annotations.findIndex(({id}) => state.rectangleInProgressId === id);
  // mutating for peformance reasons
  if (index === -1){
    state.annotations.push(boxAnnotation);
  } else {
    state.annotations[index] = boxAnnotation;
  }

  state.rectangleInProgressId = rectId;
  state.annotations = state.annotations;
  return state;
}

function finalizeTempBoundingBox(state: AppState) {
  const rectangleTool = getSelectedRectangleTool(state);
  if (!rectangleTool){
    throw new Error('Cant complete a rectagnle without a selected tool');
  }
  const index = state.annotations.findIndex(({id}) => state.rectangleInProgressId === id);
  const hasNestedClassifications = Boolean(rectangleTool.classifications);
  return {
    ...state,
    annotations: [
      ...state.annotations.slice(0, index),
      {
        ...state.annotations[index],
        geometry: restrictGeomtryToBeInsideMapBounds(state, state.annotations[index].geometry),
        editing: hasNestedClassifications
      },
      ...state.annotations.slice(index + 1),
    ],
    drawnAnnotationBounds: [],
    currentToolId: undefined,
    rectangleInProgressId: undefined,
  }
}

export const mouseMove = (state: AppState, move: MouseMove):AppState | undefined => {
  const selectedRectangleTool = getSelectedRectangleTool(state);
  if (selectedRectangleTool && Array.isArray(state.drawnAnnotationBounds) && state.drawnAnnotationBounds.length === 1) {
    return updateTempBoundingBox(state, move);
  }
  return;
}

export interface Asset {
  id: string,
  data: string,
  label: string | undefined,
  next?: string,
  previous?: string,
  typeName?: string,
  createdBy?: string,
  createdAt?: string,
}


export const labelBoxApiEmittedNewAsset = (asset: Asset | undefined) => {
  return {
    type: Actions.LABELBOX_API_EMITTED_NEW_ASSET,
    payload: {asset}
  }
}



// WEBPACK FOOTER //
// ./src/redux/app.reducer.tsx